import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InteractionCustomRoutingModule } from './interaction-custom-routing.module';
import { InteractionCustomComponent } from './interaction-custom.component';
import { TimelineComponent } from 'src/app/components/custom/timeline/timeline.component';


@NgModule({
  declarations: [InteractionCustomComponent, TimelineComponent],
  imports: [
    CommonModule,
    InteractionCustomRoutingModule
  ]
})
export class InteractionCustomModule { }
